import './index.less';
import * as React from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Upload, Divider } from '@beehive/components';
import { Modal } from '@bedrock/components'
import { TabContent } from '../components';
import { UploadFile } from 'modules/types/commons/file';
import { showAlert, isBlank, ajax, beforeUploadSuccess } from 'utils';
import _ from 'lodash';
import messages from 'messages/Workbench/ProjectDetail';
import { getTranslatedFormItem } from '../../../../utils';
import { getDetailFileList } from 'containers/OutWorkbench/ProjectDetail/Show/Detail/Bottom/Making/XiaoHao/utils';
import NewCooperate from "@mpc/common/src/features/NewCooperate";
import StatementAttachment from '@mpc/common/src/features/StatementAttachment';
import StatementAttachmentItem from '@mpc/common/src/features/StatementAttachmentItem';
import UploaderMarketingWorks from "containers/OutWorkbench/components/UploaderMarketingWorks";
import UploadHeatingBoostWorks from "containers/OutWorkbench/components/UploadHeatingBoostWorks";
import QuotationSummary from '@mpc/common/src/features/QuotationSummary';
import { localPx2rem } from '@mpc/common/src/utils';
import { useDrawerState } from 'model/drawerState';
import { outsourceDemandDownloadCaseTemplate } from '@/services/api';

export interface MakingProps {
  tabKey: string;
  templateDownloadUrl?: string;
  handleSubmitBody?: (submitBody: any) => any;
  attachementUploadUrl?: string;
  handleFormItems?: Function;
}

const FULL_COL_PROPS = {
  itemColProps: { span: 24 },
  itemLabelColProps: { span: 4 },
  itemInputColProps: { span: 20 },
};
export const FormProps = {
  mode: 'edit',
  isLabelVertical: false,
  showClientError: false,
  checkMinHeight: false,
  ...FULL_COL_PROPS,
};

const MAX_SIZE_LIMIT = 1024 * 1024 * 200;

class Making extends React.Component<MakingProps, any> {
  public static contextTypes = {
    intl: PropTypes.object,
    prefixCls: PropTypes.string,
    menuKey: PropTypes.string,
    detail: PropTypes.any,

    loadDetail: PropTypes.func,
    projectMove: PropTypes.func,
    onResize: PropTypes.func,
  };

  private formRef: React.RefObject<typeof Form> | null = null;
  private cooperateRef: React.RefObject<any> | null = null;
  private quotationSummaryRef: React.RefObject<any> | null = null;
  private statementAttachmentRef: React.RefObject<any> | null = null;
  private attachmentRef: React.RefObject<any> | null = null;



  constructor(props: MakingProps) {
    super(props);

    this.formRef = React.createRef();
    this.cooperateRef = React.createRef();
    this.statementAttachmentRef = React.createRef();
    this.attachmentRef = React.createRef();
    this.quotationSummaryRef = React.createRef();

    this.state = {
      form: {},
      showError: false,
      submitting: false,
      workNum: 0,
      isDisabledRefresh: false,
      cooperateData: null,
      statementAttachment: {
        invoice_belong_area: undefined,
        is_oversea_invoice: undefined,
        invoice_list: [],
        signed_statement_attachs: [],
      },
      FormItems: [],
    };
  }

  private handleSubmit = async () => {
    const { menuKey, detail, loadDetail, projectMove } = this.context;
    const { handleSubmitBody } = this.props;
    const { form, statementAttachment } = this.state;
    const signed_statement_attachs_blob_keys = statementAttachment?.signed_statement_attachs?.map((item: any) => item?.blob?.key)
    if (this.cooperateRef?.current?.valid() === false) {
      return;
    }
    await this.quotationSummaryRef?.current?.validateFields()
    await this.statementAttachmentRef?.current?.validateFields()
    // delete statementAttachment?.signed_statement_attachs
    if (this.formRef && this.formRef.current) {
      if (!this.formRef.current.valid()) {
        this.setState({ showError: true });
      } else {
        let hasScreenShotError = false
        let body = {
          id: detail.id,
          making: {
            is_pass: true,
            ...form,
            invoice_upload_dto: {
              ...this.state.statementAttachment,
            },
            signed_statement_attachs_blob_keys,
            ...(this.state?.cooperateData || {}),
            cooperate_accounts: this.state?.cooperateData?.cooperate_accounts?.map(v => {
              if(!hasScreenShotError) hasScreenShotError = !!v?.screen_shot_info_error_tags?.length
              return {
                ...v,
                supplier_settle_price: v?.$supplier_settle_price?.value,
                case_close_report_blob_ids: v?.case_close_report_cooperate_account_attachments?.map(n => n?.blob?.id || n?.id),
              }
            }),
            // 结案明细
            quote_settle_reports: this.state?.quote_settle_reports?.map((v: any) => {
              return {
                content: v?.content,
                quote_key: v?.quote_key,
                attach_blob_ids: v?.attachments?.map((n:any) => n?.blob?.id || n?.id).filter(Boolean),
              }
            }),
          },
        };

        const doSubmit = async () => {
          if (handleSubmitBody) {
            body = handleSubmitBody(body);
          }
          this.setState({ submitting: true });
          return projectMove(body, { menuKey })
            .then((res: any) => {
              showAlert({ type: 'success', message: res.res_msg });
              this.setState({ submitting: false });
              loadDetail();
            })
            .catch((error: any) => {
              showAlert({
                type: 'error',
                message: typeof error === 'string' ? error : error.message,
              });
              this.setState({ submitting: false });
            });
        };

        if (hasScreenShotError) {
          Modal.confirm({
            status: 'warning',
            title: '当前识别到截图错误，确定继续提交吗？',
            content:  <span >识别到截图错误，如错误属实，验收节点将被打回，可能会 <span className='making-screen-shot-warning'>影响结算时效</span> ，请仔细检查！</span>,
            cancelText: '返回检查',
            okText: '确定提交',
            onOk: () => {
              return doSubmit();
            },
            onCancel: () => {
              return;
            },
          });
          return;
        }
        
        return doSubmit();
      }
    }
  }

  private handleFormChange = (key: string, value: any) => {
    const { onResize } = this.context;
    const { form } = this.state;
    const newForm = { ...form };
    newForm[key] = value;
    this.setState({ form: newForm }, onResize);
  }

  private handleUploadChange = (options: any, key: string) => {
    const { form } = this.state;
    const { file } = options;
    const blob = _.get(file, 'response.data');
    let attachs = form[key] || [];
    const { uid } = file;
    switch (file.status) {
      case 'done':
        attachs.push({ blob_id: blob.blob_id, blob_key: blob.blob_key });
        break;
      case 'removed':
        attachs = !!blob
          ? attachs.filter((a: any) => a.blob_id !== blob.blob_id)
          : attachs.filter((a: any) => a.blob_id !== uid);
        break;
      default:
        return;
    }
    this.handleFormChange(key, attachs);
  }

  private getUploadBody = (file: UploadFile, key: string) => {
    return {
      model: 'SocialMedia::Project',
      filename: file.name,
      attach_type: key,
    };
  }

  private handleBeforeUpload = (file: any) => {
    const { intl } = this.context;
    if (file.size && file.size > MAX_SIZE_LIMIT) {
      showAlert({
        type: 'error',
        message: intl.formatMessage(messages.fileExceededLimit, {
          filename: file.name,
          fileMaxSize: '200M',
        }),
      });
      return false;
    }
    return true;
  }

  componentDidMount(): void {
    const { detail } = this.context;
    const {
      structured,
      need_content_marketing_attach,
      product_area,
      non_need_fee_control_verify,
      signed_statement_attachs,
      demand_suppliers,
      content_marketing_case_structured_version,
      is_screenshot_done,
      structured_version,
    } = detail

    const { setIsDrawerEditing } = useDrawerState.getState()
    setIsDrawerEditing(true)

    let settleReportAttachRequired = true;
    if (structured && content_marketing_case_structured_version) {
      settleReportAttachRequired = !need_content_marketing_attach
      if (!is_screenshot_done) {
        // 是否全部上传截图（主平台/付费分发）为否，则要求整单结案报告必填
        settleReportAttachRequired = true
      }
    }
    // 有结案明细上传的模块才非必填
    if (structured_version >= 1) {
      settleReportAttachRequired = false;
    }

    const newFormList = [
      {
        key: 'settle_report_attachs_blob_ids',
        label: 'settle_report_attachs',
        required: settleReportAttachRequired,
        childProps: {
          type: 'Upload',
          uploadKey: 'settle_report_attachs',
          showUploadList: { showRemoveIcon: true },
          multiple: true,
          uploadTips: 'uploadTips',
        },
      },
    ]
    // 产品等于国内 并且 是喇叭体系-喇叭内容加热助推 、喇叭体系-喇叭内容传播加热-视频图文加热
    const isShowBoost = detail?.product_area === "DOMESTIC" && detail?.need_boost_effect_data
    if (isShowBoost) {
      newFormList.unshift(
        {
          key: 'boost',
          label: '上传加热助推效果',
          required: true,
          childProps: {
            type: 'boost',
          }
        },
      )
    }
    if (need_content_marketing_attach === 1) {
      newFormList.unshift(
        {
          key: 'upload_work',
          label: '上传作品',
          required: true,
          childProps: {
            uploadKey: 'upload_work',
            type: 'link',
          },
        }
      )
    }

    if (
      !demand_suppliers?.[0]?.inner_supplier  // 是否供应商内采
      && structured  // 是否结构化
      && product_area === 'DOMESTIC'  // 是否国内
      && !non_need_fee_control_verify // 是否需走费控
    ) {
      newFormList.push(
        {
          key: 'signed_statement_attachs',
          label: '结算单附件',
          childProps: {
            type: 'attachment',
          }
        },
      )
    }


    this.setState({
      FormItems: newFormList,
      statementAttachment: {
        signed_statement_attachs: signed_statement_attachs
      }
    })
    if (!isBlank(detail)) {
      this.handleFormChange(
        'settle_report_attachs_blob_ids',
        getDetailFileList(detail)
      );
    }
  }

  // 组件销毁时
  componentWillUnmount(): void {
    const { setIsDrawerEditing } = useDrawerState.getState()
    setIsDrawerEditing(false)
  }

  downloadTemplate = () => {
    outsourceDemandDownloadCaseTemplate().then((res: any) => {
      res?.data && window.open(res?.data)
    })
  }

  handleDownLoad = (value: any) => {
    const { form } = this.state
    this.setState({ form: { ...form, signed_statement_attachs: value } })
  }

  private renderFormItemChild = (itemProps: any, childProps: any) => {
    const { intl, detail } = this.context;
    const { attachementUploadUrl } = this.props;
    const { key } = itemProps;
    const { type, ...childPropsRest } = childProps;
    switch (type) {
      case 'Upload': {
        const { uploadKey, ...uploadPropsRest } = childPropsRest;
        uploadPropsRest['uploadTips'] = (
          <>
            <span>{uploadPropsRest['uploadTips']}</span>
            <Divider vertical />
            <Button link icon="file-text-o" onClick={this.downloadTemplate}>
              {intl.formatMessage(messages.makingTemplateDownload)}
            </Button>
          </>
        );
        return (
          <div>
            <Upload
              {...uploadPropsRest}
              action={attachementUploadUrl || '/api/v1/attachments/upload'}
              beforeUpload={this.handleBeforeUpload}
              beforeSuccess={beforeUploadSuccess}
              data={(file: UploadFile) => this.getUploadBody(file, uploadKey)}
              onChange={(options: any) => this.handleUploadChange(options, key)}
            />
            {
              (detail?.structured && detail?.content_marketing_case_structured_version && !detail?.is_screenshot_done) ?
                <div className='making-content-upload-tip-text'>注：主平台/付费分发作品未上传作品截图，仍需上传结案报告。</div> :
                (
                  detail?.$contentStructured && <div className='making-content-upload-tip-text'>注：本需求单中的达人合作数据，已自动获取您在内容营销系统上传的相关数据。因此，除差旅餐饮事项(如有，请在上述合作内容中上传)外，您无需提供结案报告。如有需要，您可以下载本需求的结案信息，感谢您的配合。</div>
                )
            }
          </div>
        );
      }
      case 'link': {
        return (
          <UploaderMarketingWorks
            detail={detail}
            onDataChange={(data) => {
              this.handleFormChange('upload_work', data.num)
            }}
          />
        )
      }
      case 'boost': {
        return (
          <UploadHeatingBoostWorks
            detail={detail}
            initBoostNum={detail?.boost_effect_data_count}
            onChange={(data: any) => {
              this.handleFormChange('boost', data)
            }}
          />
        )
      }
      case 'attachment': {
        return (
          <StatementAttachment handleDownLoad={this.handleDownLoad} ref={this.attachmentRef} style={{ marginTop: '5px' }} detail={detail} />
        )
      }
      default: {
        return <span />;
      }
    }
  }

  getFormItems = () => {
    const { detail } = this.context;
    const { handleFormItems } = this.props;
    let formItems = this.state.FormItems;
    if (handleFormItems) {
      formItems = handleFormItems(_.cloneDeep(formItems), detail);
    }
    return formItems;
  }

  private renderBottom = () => {
    const { intl } = this.context;
    const { form, submitting } = this.state;
    const requiredKeys = this.getFormItems()
      .filter((i: any) => i.required)
      .map((i: any) => i.key);
    const disabled = requiredKeys.some((key: string) => isBlank(form[key]));
    return (
      <Button
        className="pull-right"
        type="primary"
        size="large"
        disabled={disabled}
        loading={submitting}
        onClick={this.handleSubmit}
      >
        {intl.formatMessage(messages.submit)}
      </Button>
    );
  }

  public render() {
    const { intl, detail } = this.context;
    const { tabKey } = this.props;
    let { showError, cooperateData } = this.state;
    const bottom = this.renderBottom();
    if (!cooperateData && detail?.project_plan_info) {
      const newPlanInfo = {
        ...detail.project_plan_info,
        cooperate_accounts: detail.project_plan_info?.cooperate_accounts?.map(v => {
          const item = detail?.demand_suppliers?.[0]?.demand_supplier_quotes?.find?.(it => {
            return it.cooperate_account_id === v.id
          })
          let $supplier_settle_price
          if (detail?.need_cooperate_account_supplier_settle_price) {
            $supplier_settle_price = {
              value: item?.need_actual_execution ? (item?.discount_quote_price_with_tax) : 0,
              currency: item?.currency
            }
          }
          return {
            ...v,
            $supplier_settle_price
          }
        })
      }
      cooperateData = newPlanInfo
      this.setState({ cooperateData });
    }

    return (
      <TabContent tabKey={tabKey} bottom={bottom} canScroll={true}>
        {(detail?.need_cooperate_account_supplier_settle_price || detail?.structured_version >= 1) && <QuotationSummary
          templateDownloadUrl={this.props.templateDownloadUrl}
          ref={this.quotationSummaryRef}
          detail={detail}
          planInfo={cooperateData || detail?.project_plan_info}
          onChange={(formData: any) => {
            this.setState({
              quote_settle_reports: formData.quote_settle_reports,
              settle_report_attachs: formData.settle_report_attachs
            });
          }}
          editType={'making'}
        />}
        {!!detail?.structured && <NewCooperate
          ref={this.cooperateRef}
          hasTitle={false}
          showBindDataKpi={false}
          view={false}
          detail={detail}
          planInfo={cooperateData || detail?.project_plan_info}
          category_id={detail.l3_category_id}
          onChange={(planInfo: any) => {
            this.setState({
              cooperateData: planInfo,
            });
          }}
          style={{ marginBottom: localPx2rem(12) }}
        />}
        <Form {...FormProps} ref={this.formRef} showError={showError}>
          {this.getFormItems().map((item: any) => {
            const translatedItem = getTranslatedFormItem(item, intl, messages);
            const { childProps, ...itemProps } = translatedItem;
            return (
              <Form.Item
                {...itemProps}
                key={itemProps.key}
                itemKey={itemProps.formKey || itemProps.key}
                className={itemProps.key}
              >
                {this.renderFormItemChild(itemProps, childProps)}
              </Form.Item>
            );
          })}
        </Form>
        {
          (detail?.product_area === 'OVERSEAS') && <div className='making-statement-attachment'>
            <StatementAttachmentItem
              ref={this.statementAttachmentRef}
              value={this.state.statementAttachment}
              onChange={e => {
                this.setState({ statementAttachment: e })
              }}
              detail={detail}
            />
          </div>
        }
      </TabContent>
    );
  }
}

export default Making;
